/**
 * @license
 * Copyright Siemens AG, 2017
 * Licensed under the Siemens Inner Source License 1.1
 */
/**
 * The class represent named links to be displayed in the user interface.
 * Optionally a css icon class can be provided for adding an icon to the link.
 */
class SiLink {
    /**
     * Creates a new link object.
     *
     * @param name The name of the link.
     * @param url The url of the link.
     * @param iconClass Optional css icon class parameter.
     */
    constructor(name, url, iconClass) {
        this.name = name;
        this.url = url;
        this.iconClass = iconClass;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { SiLink };
